/** Marks code-owned display copy; transport exception messages are never trusted. */
export class PlateTalkRequestError extends Error {}

/** Only display code-owned copy, never raw network/provider/DB exception text. */
export function plateTalkErrorMessage(code?: unknown, status?: number): string {
  switch (code) {
    case "ai_policy_unavailable":
      return "Personalized replies and protected features are unavailable because privacy approvals could not be verified. You can still ask an independent general food question, such as “fish tacos”. Photos and voice require their own availability checks.";
    case "conversation_unavailable":
    case "invalid_conversation":
      return "This conversation is unavailable. Start a new conversation and try again.";
    case "ai_cancelled":
      return "The response timed out or was cancelled. You can try a new question.";
    case "ai_configuration_error":
      return "Plate Talk’s AI connection needs attention. Please try again later.";
    case "ai_model_unavailable":
      return "Plate Talk’s AI model is temporarily unavailable. Please try again shortly.";
    case "ai_rate_limited":
      return "Plate Talk is temporarily busy. Please try again in a few minutes.";
    case "ai_providers_unavailable":
      return "Plate Talk’s AI services are temporarily unavailable. Please try again shortly.";
    case "authentication_required":
      return "Your session needs to be refreshed. Please sign in again.";
    case "member_profile_unavailable":
      return "Your Plate Talk profile could not be loaded. Please refresh and try again.";
    case "message_required":
      return "Please enter a message or attach a photo.";
    case "message_too_long":
      return "Please shorten your message to 3,000 characters or fewer.";
    case "image_too_large":
      return "This photo is too large. Please choose a smaller image.";
    case "ai_budget_exceeded":
      return "You’ve reached Plate Talk’s rolling 24-hour AI limit. Access resets automatically as earlier usage rolls out of the window.";
    case "stream_incomplete":
      return "The response was interrupted. Please check this conversation before sending again.";
    default:
      if (status === 401) return "Your session needs to be refreshed. Please sign in again.";
      if (status === 403) return "Plate Talk access could not be verified. Please refresh and try again.";
      return "Plate Talk is temporarily unavailable. Please try again shortly.";
  }
}
